const AUTH_ERROR_MESSAGES: Record<string, string> = {
  ACCOUNT_EXPIRED: 'Ce compte démo est arrivé à expiration. Contactez votre administrateur pour le réactiver.',
  BANNED_USER: 'Ce compte a été désactivé. Veuillez contacter un administrateur.',
  EMAIL_NOT_VERIFIED: 'Votre adresse e-mail n’est pas encore vérifiée. Un nouveau lien de confirmation vient de vous être envoyé.',
  EMAIL_ALREADY_VERIFIED: 'Cette adresse e-mail est déjà vérifiée.',
  EMAIL_MISMATCH: 'Cette action ne peut pas être exécutée pour une autre adresse e-mail depuis la session courante.',
  EMAIL_RATE_LIMIT_EXCEEDED: 'Trop de demandes d’e-mail sur cette période. Veuillez réessayer dans quelques minutes.',
  FAILED_TO_SEND_VERIFICATION_EMAIL: 'Impossible d’envoyer l’e-mail de confirmation pour le moment.',
  INVALID_TOKEN: 'Le lien est invalide ou a expiré.',
  INVALID_EMAIL: 'Adresse e-mail invalide.',
  INVALID_PASSWORD: 'Le mot de passe actuel est invalide.',
  INVALID_EMAIL_OR_PASSWORD: 'Adresse e-mail ou mot de passe invalide.',
  PASSWORD_TOO_LONG: 'Le mot de passe est trop long.',
  PASSWORD_TOO_SHORT: 'Le mot de passe est trop court.',
  PASSWORD_ALREADY_SET: 'Le mot de passe a déjà été défini pour ce compte.',
  RESET_PASSWORD_DISABLED: 'La réinitialisation du mot de passe est indisponible.',
  SESSION_NOT_FRESH: 'Cette action sensible nécessite une session récente. Veuillez vous reconnecter puis réessayer.',
  TOKEN_EXPIRED: 'Le lien a expiré.',
  USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL: 'Un compte existe déjà avec cette adresse e-mail.',
  USER_ALREADY_EXISTS: 'Un compte existe déjà avec cette adresse e-mail.',
  VERIFICATION_EMAIL_NOT_ENABLED: 'La vérification de l’adresse e-mail est indisponible.',
  FAILED_TO_CREATE_USER: 'Impossible de créer le compte pour le moment.',
  EMAIL_PASSWORD_DISABLED: 'La connexion par e-mail et mot de passe est indisponible.',
  CREDENTIAL_ACCOUNT_NOT_FOUND: 'Aucun mot de passe n’est encore défini pour ce compte.',
  YOU_ARE_NOT_ALLOWED_TO_LIST_USERS: 'Votre compte n’est pas autorisé à consulter la liste des utilisateurs.',
  YOU_ARE_NOT_ALLOWED_TO_CREATE_USERS: 'Votre compte n’est pas autorisé à créer de nouveaux utilisateurs.',
  YOU_ARE_NOT_ALLOWED_TO_CHANGE_USERS_ROLE: 'Votre compte n’est pas autorisé à modifier les rôles des utilisateurs.',
  YOU_ARE_NOT_ALLOWED_TO_BAN_USERS: 'Votre compte n’est pas autorisé à modifier le statut des utilisateurs.',
  YOU_ARE_NOT_ALLOWED_TO_DELETE_USERS: 'Votre compte n’est pas autorisé à supprimer des utilisateurs.',
  YOU_ARE_NOT_ALLOWED_TO_SET_NON_EXISTENT_VALUE: 'Le rôle demandé n’est pas autorisé.',
  INVALID_ROLE_TYPE: 'Le rôle demandé est invalide.',
  YOU_CANNOT_BAN_YOURSELF: 'Vous ne pouvez pas désactiver votre propre compte.',
  YOU_CANNOT_REMOVE_YOURSELF: 'Vous ne pouvez pas supprimer votre propre compte.',
  AVATAR_IMAGE_INVALID: 'Cette image ne peut pas être utilisée comme avatar.',
  AVATAR_IMAGE_TOO_LARGE: 'Le fichier avatar dépasse la taille maximale autorisée.',
  OBJECT_STORAGE_NOT_CONFIGURED: 'Le stockage objet n’est pas configuré sur cet environnement.',
  OBJECT_STORAGE_PUBLIC_URL_MISSING: 'Le stockage public des avatars n’est pas correctement configuré.',
};

function extractErrorCode(error: unknown): string | null {
  if (!error || typeof error !== 'object') {
    return null;
  }

  if ('code' in error && typeof error.code === 'string') {
    return error.code;
  }

  if (
    'error' in error &&
    error.error &&
    typeof error.error === 'object' &&
    'code' in error.error &&
    typeof error.error.code === 'string'
  ) {
    return error.error.code;
  }

  if ('message' in error && typeof error.message === 'string') {
    return error.message;
  }

  return null;
}

export function getAuthErrorMessage(error: unknown): string {
  const code = extractErrorCode(error);

  if (code && code in AUTH_ERROR_MESSAGES) {
    return AUTH_ERROR_MESSAGES[code];
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return 'Une erreur est survenue. Veuillez réessayer dans un instant.';
}
